import * as logger from 'loglevel';
import axiosWrapper from '../../helpers/axiosWrapper';
import { NO_DURATION_DEFINED } from '../../helpers/axiosWrapper/cache';

/**
 * Makes sure the fares response is complain with a basic schema
 * @param {*} fares
 */
const validateFaresResponse = (fares) => {
  const validation = { isValid: true, message: '' };
  if (!fares || !Array.isArray(fares)) {
    validation.isValid = false;
    return {
      isValid: false,
      data: fares,
      message: 'INTEGRATION__TRAVEL_CLASSES: BreakingDeals must be an Array'
    };
  }
  return validation;
};

/**
 * The group routes API returns the data in non linear format
 * so this function will intend normalize the data for the components
 * @param {*} faresRawData
 * @param {*} query
 */
const transformData = (faresRawData) => {
  const all = { label: `cmp-travel-class--all`, value: `ALL` };
  const fares = faresRawData.map((item) => {
    return { label: `cmp-travel-class--${item.toLocaleLowerCase()}`, value: item };
  });

  return [all, ...fares];
};

/**
 * Retrieve fares from the GroupRoutes Endpoint
 * @param {*} filter
 * @param {*} integrationSettings
 */
const getTravelClasses = (filters, integrationSettings, meta, pageContext) => {
  return new Promise((resolve, reject) => {
    if (!integrationSettings) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings** not specified.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }
    const { v1BreakingDealsTravelClasses: faresApiSettings } = integrationSettings;
    const {
      cache = false,
      cacheDuration = NO_DURATION_DEFINED,
      visualizationType = 'GRID'
    } = faresApiSettings;
    if (!faresApiSettings || !faresApiSettings.method || !faresApiSettings.endPoint) {
      const MESSAGE = `INTEGRATION__FARES: **integrationSettings.breakingDeals** configuration issues.`;
      logger.error(MESSAGE);
      reject(MESSAGE);
    }

    axiosWrapper(
      {
        method: faresApiSettings.method,
        url: `${faresApiSettings.endPoint}?market=${filters.market}&visualization=${visualizationType} `,
        headers: { ...faresApiSettings.headers }
      },
      {
        resource: 'INTEGRATION__TRAVEL_CLASSES__BREAKING_DEALS',
        meta,
        integrationSettings,
        pageContext,
        cache,
        cacheDuration
      }
    )
      .then((resp) => {
        const validation = validateFaresResponse(resp.data);
        if (validation.isValid) {
          logger.info('INTEGRATION__TRAVEL_CLASSES: Successful request', resp.data);
          const fares = transformData(resp.data);
          resolve(fares);
        } else {
          logger.error(validation.message, validation.data);
          reject(resp.data);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export { getTravelClasses };
